//dependencias
import React, { Component } from 'react';

//componentes
import AnioEscolar from './anioEscolar'

class Index extends Component {

    render(){
        return(
            <div>
                <AnioEscolar />
            </div>
        );
    }

}
export default Index;